module.exports = __webpack_public_path__ + "img/WU.c70aa48.png";